const selectServicesByReservationType = (reservationType) => ({
  path: `/arrival-departure-formalities?filters[reservation_type]=${encodeURIComponent(reservationType)}&pagination[page]=1&pagination[pageSize]=1000`,
  method: 'GET',
  get: 'data',
  auth: true,
  fallback: [],
  transform: (data) =>
    data.map((item) => ({
      name: item.attributes.value,
      id: item.id,
    })),
});

export const API = {
  selectAD: selectServicesByReservationType('ARRIVAL & DEPARTURE FORMALITIES'),
  selectCashDeclaration: selectServicesByReservationType('CASH DECLARATION'),
  selectImmigrationFormalities: selectServicesByReservationType('IMMIGRATION FORMALITIES'),
  selectSanification: selectServicesByReservationType('SANITATION FORMALITIES'),
  selectCentralAgent: selectServicesByReservationType('CENTRAL AGENT'),
  selectBerthReservation: selectServicesByReservationType('BERTH RESERVATION'),
  selectBuoyReservation: selectServicesByReservationType('BUOY RESERVATION'),
};
